module.exports = require('./noop')
